// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component, PropTypes } from '@plesk/ui-library';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import RouteRequire from './RouteRequire';
import routes from './routes';

const ExternalRedirect = ({ match }) => {
    location.href = match.url;

    return null;
};

class App extends Component {
    getChildContext() {
        return {
            config: this.props.config,
        };
    }

    getConfirmation = (message, callback) => {
        try {
            const { callback: callbackReturnValue } = JSON.parse(message);

            if (typeof callbackReturnValue !== 'undefined') {
                callback(callbackReturnValue);
            } else {
                throw new Error();
            }
        } catch (e) {
            // eslint-disable-next-line no-alert
            callback(window.confirm(message));
        }
    };

    render() {
        return (
            <BrowserRouter getUserConfirmation={this.getConfirmation}>
                <Switch>
                    {routes.map(route => (
                        <RouteRequire key={route.path} {...route} />
                    ))}
                    <Route path="*" component={ExternalRedirect} />
                </Switch>
            </BrowserRouter>
        );
    }
}

App.propTypes = {
    config: PropTypes.object.isRequired,
};

App.childContextTypes = {
    config: PropTypes.object,
};

export default App;



// WEBPACK FOOTER //
// ./plesk/App.js